import type { ExpressCheckoutOptions } from '../typings/configuration.types';

interface ButtonsAvailability {
    isKlarnaButtonAvailable: boolean | null;
    isApplePayAvailable: boolean | null;
}

interface ButtonsAppearance {
    isApplePayButtonDisplayed: boolean | null;
    isPaypalButtonDisplayed: boolean;
    isKlarnaButtonDisplayed: boolean;
}

const getIsAnyButtonReady = (
    expressCheckoutOptions: Partial<ExpressCheckoutOptions> | null | undefined,
    buttonsAvailability: Partial<ButtonsAvailability>,
    buttonsAppearance: Partial<ButtonsAppearance>,
) => {
    if (!expressCheckoutOptions) {
        return false;
    }

    const { klarnaExpressCheckoutEnabled, paypalExpressCheckoutEnabled, applePayExpressCheckoutEnabled } =
        expressCheckoutOptions;
    const { isKlarnaButtonAvailable, isApplePayAvailable } = buttonsAvailability;
    const { isApplePayButtonDisplayed } = buttonsAppearance;

    const isKlarnaReady = klarnaExpressCheckoutEnabled && isKlarnaButtonAvailable !== null;
    // paypal does not have 'available' flag, so we assume enabled = either loading or already displayed
    const isPaypalReady = paypalExpressCheckoutEnabled;
    const isApplePayReady =
        applePayExpressCheckoutEnabled && isApplePayAvailable !== null && isApplePayButtonDisplayed !== null;
    return Boolean(isKlarnaReady) || Boolean(isPaypalReady) || Boolean(isApplePayReady);
};

export default getIsAnyButtonReady;
